import React from 'react';
import {connect} from 'react-redux';
import {sendEmailToClient} from '../../redux/actions';
import {Form, Col,Button, Modal } from 'react-bootstrap';
import { Formik, getIn } from 'formik';
import * as yup from 'yup';
import {Message} from './Message';

const schema = yup.object().shape({
    email: yup.string().email('This must be a valid email').required('Please enter your email')
  });

class MyVerticallyCenteredModal extends React.Component {
    constructor(props){
        super(props);
        this.state ={
            showOk: false
        }
        this.saveLater = this.saveLater.bind(this);
    }
    async saveLater(values){
        // console.log('on ok',values.email);
        this.props.sendEmailToClient(values.email,this.props.form);
        setTimeout( () => {
            this.setState({showOk:true});
            this.props.setModalShow(false);
        },1000);
    }
    render(){
    if(this.state.showOk){
        return(
            <Message title="9 to Know" message="An email has been successfully sent!" />
        );
    }
    else{
        return (
        <Modal
            // {...this.props}
            show={this.props.show}
            onHide={this.props.onHide}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Formik
                        validateOnChange={false}
                        validateOnBlur={false}
                        initialValues={this.props}
                        validationSchema={schema}
                        onSubmit={this.saveLater}
                    >
                    {({
                            handleSubmit,
                            handleChange,
                            setFieldValue,
                            setFieldTouched,
                            values,
                            errors,
                            touched
                        }) => (
        <Form onSubmit={handleSubmit} >
            <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
                {this.props.heading || '9 to know'}
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                                <Form.Row>
                                <Form.Group as={Col} md="12" controlId="validationFormikEmail">
                                <Form.Label className="required">{this.props.description}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={getIn(values, `email`)}
                                        onChange={e => {setFieldValue( `email`,e.target.value);
                                        setFieldTouched( `email`,true);}}
                                        isValid={getIn(touched, `email`) && !getIn(errors, `email`)}
                                        isInvalid={getIn(errors, `email`) }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { getIn(errors, `email`) }
                                    </Form.Control.Feedback> 
                                </Form.Group>
                                </Form.Row>
                            
            </Modal.Body>
            <Modal.Footer style={{justifyContent: 'space-between'}}>
            <button type="button" className='btn btn-primary float-left' onClick={this.props.onHide}>Close</button>
            <button className='btn btn-primary float-right' type="submit">{this.props.btnoktext || 'Ok'}</button>
            </Modal.Footer>
        </Form>
        )}
        </Formik>
        </Modal>
        );
    }
    }
  }
  
class Dialog extends React.Component {
    constructor(props){
        super(props);
        this.state ={
            modalShow:false
        }
        this.setModalShow = this.setModalShow.bind(this);
    }
    setModalShow(shouldShow){
        this.setState({modalShow:shouldShow})
    }
    render(){
        return (
        <React.Fragment>

            <Button variant="primary" style={{"marginLeft":"20px"}} onClick={() => this.setModalShow(true)}>
            {this.props.mainbuttontext || 'Dialog'}
            </Button>
    
            <MyVerticallyCenteredModal
            {...this.props}
            email={this.props.form && this.props.form.client ? this.props.form.client.email:''}
            show={this.props.modalShow || this.state.modalShow}
            onHide={() => this.setModalShow(false)}
            setModalShow={this.setModalShow}
            />
        </React.Fragment>
        );
    }
  }
  const mapStateToProps = (state,ownProps) => {
      return {
          ...state.mainState,
          ownProps
      };
  }
  const mapDispatchToProps = dispatch => ({
    sendEmailToClient:  (email,form) => dispatch(sendEmailToClient(email,form))
  });
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Dialog)